'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('videoConf', {
                parent: 'entity',
                url: '/videoConf',
                data: {
                    roles: ['OP_VIEW_CONFERENCES', 'OP_MANAGE_CONFERENCES'],
                    pageTitle: 'lmsApp.videoConf.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/videoConf/videoConfs.html',
                        controller: 'videoConfController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('videoConf');
                        return $translate.refresh();
                    }]
                }
            })
            .state('videoConfDetail', {
                parent: 'entity',
                url: '/videoConf/:id',
                data: {
                    roles: ['OP_VIEW_CONFERENCES', 'OP_MANAGE_CONFERENCES'],
                    pageTitle: 'lmsApp.videoConf.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/videoConf/videoConf-detail.html',
                        controller: 'videoConfDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('videoConf');
                        return $translate.refresh();
                    }]
                }
            });
    });
